import React from 'react';
import { Button } from '@noths/polaris-design-system-core-components';

import * as styles from './ProductPages.styles';

interface PaginationButtonLinkProps {
  children: React.ReactNode;
  href: string;
  onClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

export const PaginationButtonLink = ({ children, href, onClick }: PaginationButtonLinkProps) => {
  return (
    <div css={styles.loadPageWrapper}>
      <Button href={href} onClick={onClick} rel="nofollow">
        {children}
      </Button>
    </div>
  );
};
